import { OrderType } from 'graphql-api/gql-api-interfaces';

import {
  BusinessState,
  DataState,
  DeliveryPeriodType,
} from '../../../models/config-strip-state.models';

import { getAvailableInventories } from './get-available-inventories';
import { calculateUsedInventories } from './used-inventories';

export const makeQuantitiesChange = ({
  state,
  data,
  previousQuantity,
  quantity,
  productId,
  deliveryShopKey,
  deliveryPeriodType,
  deliveryPeriod,
  orderType,
}: {
  state: BusinessState;
  data: DataState;
  productId: string;
  previousQuantity: number;
  quantity: number;
  deliveryShopKey: string;
  deliveryPeriodType: DeliveryPeriodType;
  deliveryPeriod: string;
  // USED TO BE orderType?:
  orderType: OrderType;
}) => {
  /**
   * Algorithm: "oldValue + (newValue - oldValue)"
   * to calculate difference from existing and new one;
   * Examples:
   * Ex1: 5 -> 7; 5 + (7 - 5) = 2 - difference is +2
   * Ex2: 10 -> 5; 10 + (5 - 10) = 5 - difference is +5;
   * Ex3: 10 -> 0; 10 + (0 - 10) = 0 - difference is +0;
   * Ex4: 0 -> 2; 0 + (2 - 0) = 2 - difference is +2;
   */
  const difference = previousQuantity + (quantity - previousQuantity);

  const inventories = getAvailableInventories({
    state,
    data,
    productId,
    deliveryShopId: deliveryShopKey,
    deliveryPeriodType,
    orderType,
    deliveryPeriod,
    deliveryWindow: data.product?.deliveryWindowType,
  });

  const inventoryUpdate = calculateUsedInventories({
    previousQuantity,
    difference,
    availableInventories: inventories,
    usedInventoriesForDeliveryShop: state.usedInventories,
    deliveryShopId: deliveryShopKey,
    deliveryPeriod,
  });

  const usedInventories = {
    ...state.usedInventories,
    [deliveryShopKey]: {
      ...state.usedInventories[deliveryShopKey],
      [deliveryPeriod]: inventoryUpdate.usedInventories,
    },
  };

  return {
    inventoryUpdate,
    inventories,
    usedInventories,
    difference,
  };
};
